import TooltipIcon from './tooltip-icon-component';
import './tooltip-icon.scss';

const MODULE_NAME = 'App.common.widgets.tooltip-icon';
const module = angular.module(MODULE_NAME, [])
    .directive(TooltipIcon.DIRECTIVE_NAME, TooltipIcon);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/common/widgets/tooltip-icon/tooltip-icon-module.js